import { FelaCSSWithCustomSelectors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSSWithCustomSelectors;
  slideWrap: (noPadding: boolean) => FelaCSSWithCustomSelectors;
}

const styles: IStyles = {
  wrapper: {
    flexDirection: 'row',
    alignItems: 'stretch',
    overflowX: 'auto',
    overflowY: 'hidden',
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
  slideWrap: (noPadding) => ({
    flexShrink: 0,
    '&:first-child': {
      marginLeft: noPadding ? 0 : 4,
    },
  }),
};

export default styles;
